import { useRetrieveListByGet } from 'src/compass/shared/hooks/reactQuery/useRetrieveListByGet';

export default function useSiteProperties() {
  const query = useRetrieveListByGet({
    url: 'Public/Properties/Site',
    staleTime: Infinity,
  });

  const databaseName = query.data?.databaseName?.toLowerCase();

  const isProductionDatabase = !databaseName || databaseName === 'production';

  // Both are empty unless the API is running against a provisioned environment's
  // database - the backend resolves that from the catalog it is connected to,
  // so the frontend does no environment lookup of its own.
  const documentation: string = query.data?.documentation ?? '';

  // A path relative to the API base (e.g. "Public/Properties/SiteAttachment"),
  // so it has to be resolved against REACT_APP_API_URL - which already ends in
  // "/api/" - to be usable as an href.
  const attachmentPath: string = query.data?.attachmentUrl ?? '';
  const attachmentUrl = attachmentPath
    ? `${process.env.REACT_APP_API_URL}${attachmentPath}`
    : '';

  // The name that download saves as, resolved server-side - so the dialog can
  // label the link with the filename the user will end up with.
  const attachmentFilename: string = query.data?.attachmentFilename ?? '';

  // Whether there is anything for the header's environment dialog to show. When
  // false the header tag stays a plain label, which is the case on dev2,
  // production and ordinary local dev.
  const hasEnvironmentInfo = documentation.trim() !== '' || attachmentUrl !== '';

  return {
    ...query,
    isProductionDatabase,
    documentation,
    attachmentUrl,
    attachmentFilename,
    hasEnvironmentInfo,
  };
}
